import { StepperDataType } from "@revmatics/catalyst";

export const onboardingSteps: StepperDataType = [
  { step: 1, title: "Getting Started", variant: "outline" },
  { step: 2, title: "Growth & Marketing Setup", variant: "outline" },
  { step: 3, title: "Select Creators", variant: "outline" },
  { step: 4, title: "Generate Creator Brief", variant: "outline" },
  // { step: 5, title: "Generate Landing Page", variant: 'outline' },
];
